import ModalVistaPrevia from 'components/Admin/Certificados/ModalVistaPrevia'
import { UserData } from 'components/Sidebar/Sidebar_Principal'
import { alertService } from 'components/Varios/alert_service'
import Cargando from 'components/Varios/Cargando'
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos'
import { GetDocumentVistaPrevia } from 'helpers/files'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { authenticationService } from 'services/authentication.service'
import { ObtenerAniosHistorial, ObtenerHistorial } from './FunctionsHistorialAprobacions'
import TableHistorialAprobaciones from './TableHistorialAprobaciones'
import { HistorialSolicitudes } from './TypesHistorialSolicitudes'


type StateHistorialAprobacion = {
    aniosDisponibles: number[],
    historial: HistorialSolicitudes[],
    loading: boolean,
    error: boolean,
    anioSeleccionado:number

}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}


export default function HistorialAprobaciones() {

    const defaultStateHistorial: StateHistorialAprobacion = {
        aniosDisponibles: [],
        historial: [],
        loading: false,
        error: false,
        anioSeleccionado:-1
    }

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {

        loading: false,
        url: ""
    }

    const [stateHistorial, setstateHistorial] = useState<StateHistorialAprobacion>(defaultStateHistorial)
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)


    async function ObtenerInformacionAniosHistorial() {
        setstateHistorial({ ...stateHistorial, loading: true })
        const respuesta = await ObtenerAniosHistorial();
        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial de aprobaciones");
            setstateHistorial({ ...stateHistorial, loading: false, error: true })

        }
        else {
            const anioSeleccionado = respuesta.dataResponse[0]
            setstateHistorial({ ...stateHistorial, loading: false, aniosDisponibles: respuesta.dataResponse, anioSeleccionado})

        }

    }


    useEffect(() => {
        ObtenerInformacionAniosHistorial();
    }, [])


   


    const GetHistorialByYear = useCallback(async (anio: number) => {

        setstateHistorial({ ...stateHistorial, loading: true })
        const respuesta = await ObtenerHistorial(anio)
        
        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial de aprobaciones")
            setstateHistorial({ ...stateHistorial, error: true, loading: false })
        }
        else {
            setstateHistorial({ ...stateHistorial, historial: respuesta.dataResponse, loading: false , anioSeleccionado:anio})
        }
    }, [stateHistorial])


    async function ConsultarHistorial(stateHistorial: StateHistorialAprobacion) {
        setstateHistorial({ ...stateHistorial, loading: true })
        const anio = stateHistorial.anioSeleccionado
        const respuesta = await ObtenerHistorial(anio)
        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial de aprobaciones")
            setstateHistorial({ ...stateHistorial, error: true, loading: false })
        }
        else {
            setstateHistorial({ ...stateHistorial, historial: respuesta.dataResponse, loading: false })
        }

    }

    const onClickVerDoc = useCallback(
        async (referencia: string) => {
            setstateModalVP({ ...stateModalVP, loading: true })
            const datosUsuario: UserData = authenticationService.currentUserValue;
            const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
            setstateModalVP({ ...stateModalVP, loading: false, url })
        }, [stateModalVP])



    useEffect(() => {
        if (stateHistorial.aniosDisponibles.length > 0) {
            ConsultarHistorial(stateHistorial);
        }
    }, [stateHistorial.aniosDisponibles])



    const tablaHistorial = useMemo(() => {
        if (stateHistorial.loading) {
            return <Cargando />
        }
        else if (stateHistorial.error) {
            return <div>No ha sido posible obtener información</div>
        }
        else if (!stateHistorial.error && (stateHistorial.aniosDisponibles.length === 0 && stateHistorial.historial.length === 0)) {
            return <div>No hay historial de solicitudes por mostrar</div>

        }
        else if (!stateHistorial.loading && stateHistorial.historial.length > 0) {
            return (
                <TableHistorialAprobaciones
                    anioSeleccionado={stateHistorial.anioSeleccionado}
                    dataFilas={stateHistorial.historial}
                    onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}
                    onChangeAnio= { (a:number) =>  GetHistorialByYear(a)}
                    
                />
            )
        }
    }, [stateHistorial])



    return (
        <div className="content">
            <div className="titulo_seccion mb-5"> HISTORIAL SOLICITUDES </div>

            {
                tablaHistorial
            }
            <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Documento solicitud'
                urlArchivo={stateModalVP.url}
                botonCerrar={true}


            />

        </div>
    )
}
